import { SvgIcon } from "@mui/material";
import { IconProps } from "./_interface";

const IconProfile = (props: IconProps) => {
  return (
    <SvgIcon {...props} color="inherit" viewBox="0 0 29 28">
      <path
        d="M18.2468 7.77482C18.2468 9.93618 16.4947 11.6883 14.3333 11.6883C12.172 11.6883 10.4198 9.93618 10.4198 7.77482C10.4198 5.61346 12.172 3.86133 14.3333 3.86133C16.4947 3.86133 18.2468 5.61346 18.2468 7.77482ZM8.50397 23.347C6.23981 23.347 4.94738 20.7622 6.30587 18.9509C7.92567 16.7911 10.4678 15.5201 13.1675 15.5201H15.4992C18.1989 15.5201 20.741 16.7911 22.3608 18.9509C23.7193 20.7622 22.4269 23.347 20.1627 23.347H8.50397Z"
        fill="transparent"
        stroke="#2E434D"
        strokeWidth="1.5"
      />
    </SvgIcon>
  );
};

export default IconProfile;
